module.exports = __webpack_public_path__ + "img/arrow-hint-navigation-right.2d02253a.png";